module.exports = __webpack_public_path__ + "img/moka.a17a08c5.png";